import { type RouteRecordRaw } from 'vue-router';

import { useAuth } from '@/hooks/auth/use-auth';
import NotFound from '@/pages/NotFound.vue';

export const routes: Array<RouteRecordRaw> = [
  {
    path: '/asset/:tickerSymbol(EUA_DAILY|UKA_DAILY)',
    name: 'asset',
    component: () => import('@/pages/asset/index.vue'),
    redirect: (to) => `/asset/${to.params.tickerSymbol as string}/performance`,
    children: [
      {
        path: 'performance',
        name: 'assetPerformance',
        component: () => import('@/pages/asset/Performance.vue'),
      },
      {
        path: 'impact',
        name: 'assetImpact',
        component: () => import('@/pages/asset/Impact.vue'),
      },
      {
        path: 'product-information',
        name: 'assetProductInformation',
        component: () => import('@/pages/asset/ProductInformation.vue'),
      },
    ],
  },
  {
    path: '/',
    redirect: '/asset/EUA_DAILY/performance',
  },
  {
    path: '/withdraw',
    name: 'withdraw',
    component: () => import('@/pages/Withdraw.vue'),
    meta: { authRequired: true, layout: 'empty' },
  },
  {
    path: '/sell/:tickerSymbol(EUA_DAILY)',
    name: 'sell',
    component: () => import('@/pages/Sell.vue'),
    meta: { authRequired: true, layout: 'empty' },
  },
  {
    path: '/invest/:tickerSymbol(EUA_DAILY)',
    name: 'invest',
    component: () => import('@/pages/Invest.vue'),
    meta: { authRequired: true, layout: 'empty' },
  },
  {
    path: '/deposit/:tickerSymbol(EUA_DAILY)',
    name: 'deposit',
    component: () => import('@/pages/Deposit.vue'),
    meta: { authRequired: true, layout: 'empty' },
  },
  {
    path: '/kyc',
    name: 'kyc',
    component: () => import('@/pages/Kyc.vue'),
    beforeEnter: async (_to, _from, next) => {
      const { isAuthorized, waitForAuthSync } = useAuth();
      await waitForAuthSync.value.promise;
      if (isAuthorized('KYC_VERIFIED')) {
        return next({
          path: '/',
        });
      } else {
        next();
      }
    },
    meta: { authRequired: true, layout: 'empty' },
  },
  {
    path: '/asset/performance',
    redirect: '/asset/EUA_DAILY/performance',
  },
  {
    path: '/asset/impact',
    redirect: '/asset/EUA_DAILY/impact',
  },
  {
    path: '/asset/product-information',
    redirect: '/asset/EUA_DAILY/product-information',
  },
  {
    path: '/portfolio',
    name: 'portfolio',
    component: () => import('@/pages/Portfolio.vue'),
  },
  {
    path: '/investment/:orderId',
    name: 'investment',
    component: () => import('@/pages/Investment.vue'),
  },
  {
    path: '/referral',
    name: 'referral',
    component: () => import('@/pages/Referral.vue'),
    meta: { authRequired: true },
  },
  {
    path: '/resources',
    name: 'resources',
    component: () => import('@/pages/Resources.vue'),
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/pages/Settings.vue'),
    meta: { authRequired: true },
  },
  {
    path: '/investment-strategy',
    name: 'investmentStrategy',
    component: () => import('@/pages/InvestmentStrategy.vue'),
    meta: { authRequired: true },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
    meta: {
      layout: 'empty',
    },
  },
];
